/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Project restore info
 */
import { ValidateUtils } from 'app/shared/utils';

export class ProjectRestoreInfo { 
    /**
     * Project version number to restore (from Project Timeline)
     */
    versionNumber?: string;
    /**
     * Restore message
     */
    restoreMessage?: string;

    constructor(item?: Partial<ProjectRestoreInfo>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            versionNumber: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.versionNumber : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            restoreMessage: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.restoreMessage : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProjectRestoreInfo.isValid,
        };
    }

    static isValid(obj: ProjectRestoreInfo): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProjectRestoreInfo.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.versionNumber.isValid(item);
            result = result && validationObject.restoreMessage.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

